import { apiClient } from '@rti/shared';
import type { FreightosData } from '@rti/shared';

let freightosCache: FreightosData[] | null = null;

export const getFreightosData = async (force = false): Promise<FreightosData[]> => {
  if (freightosCache && !force) return freightosCache;
  try {
    const data = await apiClient.getFreightosData();
    freightosCache = data ?? [];
    return freightosCache;
  } catch {
    const cached = await apiClient.readDataFromCache<FreightosData[]>('FREIGHTOS');
    if (cached) {
      freightosCache = cached;
      return cached;
    }
    return [];
  }
};

export const clearFreightosCache = () => {
  freightosCache = null;
};

export interface TradelaneOption {
  tradelane: string;
  origin: string;
  destination: string;
  mode: string;
}

export const METRIC_KEYS = [
  'maximum',
  'high',
  'medium_high',
  'medium',
  'medium_low',
  'low',
  'minimum',
  'average',
] as const;

export type MetricKey = (typeof METRIC_KEYS)[number];

export const METRIC_LABELS: Record<MetricKey, string> = {
  maximum: 'Maximum',
  high: 'High',
  medium_high: 'Medium/High',
  medium: 'Medium',
  medium_low: 'Medium/Low',
  low: 'Low',
  minimum: 'Minimum',
  average: 'Average',
};

export const METRIC_ORDER: Record<MetricKey, number> = {
  maximum: 8,
  high: 7,
  medium_high: 6,
  medium: 5,
  average: 4,
  medium_low: 3,
  low: 2,
  minimum: 1,
};

export const METRIC_DESCRIPTIONS: Record<MetricKey, string> = {
  low: 'Low range rates during the period',
  medium_low: 'Medium-low range rates during the period',
  medium: 'Medium range rates during the period',
  medium_high: 'Medium-high range rates during the period',
  high: 'High range rates during the period',
  maximum: 'Maximum rate reached during the period',
  minimum: 'Minimum rate reached during the period',
  average: 'Average rate across the period',
};

export const DEFAULT_METRICS: MetricKey[] = ['high', 'average', 'low'];
